import React from 'react';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';

const PayerAltNamesModal = ({ isOpen, handleClose, altNames = [] }) => {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      handleClose={handleClose}
      title="Also known as"
      footer={
        <div className="flex w-full justify-end">
          <Button variant="tertiary" text="Close" size="small" onClick={handleClose} />
        </div>
      }>
      <div className="max-h-[400px] overflow-y-auto">
        <ul className="list-inside list-disc space-y-2 pl-4">
          {altNames.map((name, index) => (
            <li key={index} className="text-sm">
              {name}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default PayerAltNamesModal;
